/**
 * Monaco ambient types for AssetManager + live asset-path autocomplete.
 *
 * ASSET_MANAGER_DTS is appended to the @gotti/core ambient module so
 * `import AssetManager from '@gotti/core'` resolves with full method types and a
 * default export. buildAssetPathsDts() produces a SEPARATE augmentation that
 * merges the current asset paths into the open AssetPathRegistry interface —
 * re-registered on every asset change so `AssetManager.getImage('…')` autocompletes.
 *
 * NOTE: hand-authored to mirror packages/core/src/assets/AssetManager.ts. Keep in
 * sync if the AssetManager surface changes. If buildAmbientModules() (in monacoUtils)
 * ever ingests the assets .d.ts directly, drop ASSET_MANAGER_DTS to avoid a double
 * declaration of AssetManager in the @gotti/core ambient module.
 */
export const ASSET_MANAGER_DTS = `
export interface AssetPathRegistry {}
export type AssetPath = keyof AssetPathRegistry extends never ? string : keyof AssetPathRegistry;
export interface AssetManagerApi {
  getImage(path: AssetPath): HTMLImageElement;
  getJSON<T = unknown>(path: AssetPath): T;
  getFile(path: AssetPath): Uint8Array;
  getUrl(path: AssetPath): string;
  has(path: AssetPath): boolean;
  list(folder?: string): string[];
}
// Host-only methods (__init, __reset) are intentionally omitted from the editor surface.
export const AssetManager: AssetManagerApi;
export default AssetManager;
`;

export function buildAssetPathsDts(paths: string[]): string {
  const lines = paths.map((p) => `    ${JSON.stringify(p)}: true;`).join('\n');
  return `export {};
declare module '@gotti/core' {
  interface AssetPathRegistry {
${lines}
  }
}
`;
}
